import React from 'react';

type WorkSpaceIconProps = {
  width?: string;
  height?: string;
  color?: string;
};

function WorkSpaceIcon({
  width = '60',
  height = '60',
  color = 'white',
}: WorkSpaceIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='40' height='40' rx='10' fill='#6267AC' />
      <path
        d='M12 13C12 12.7348 12.1054 12.4804 12.2929 12.2929C12.4804 12.1054 12.7348 12 13 12H17C17.2652 12 17.5196 12.1054 17.7071 12.2929C17.8946 12.4804 18 12.7348 18 13V18C18 18.2652 17.8946 18.5196 17.7071 18.7071C17.5196 18.8946 17.2652 19 17 19H13C12.7348 19 12.4804 18.8946 12.2929 18.7071C12.1054 18.5196 12 18.2652 12 18V13ZM22 13C22 12.7348 22.1054 12.4804 22.2929 12.2929C22.4804 12.1054 22.7348 12 23 12H27C27.2652 12 27.5196 12.1054 27.7071 12.2929C27.8946 12.4804 28 12.7348 28 13V15C28 15.2652 27.8946 15.5196 27.7071 15.7071C27.5196 15.8946 27.2652 16 27 16H23C22.7348 16 22.4804 15.8946 22.2929 15.7071C22.1054 15.5196 22 15.2652 22 15V13ZM12 24C12 23.7348 12.1054 23.4804 12.2929 23.2929C12.4804 23.1054 12.7348 23 13 23H17C17.2652 23 17.5196 23.1054 17.7071 23.2929C17.8946 23.4804 18 23.7348 18 24V27C18 27.2652 17.8946 27.5196 17.7071 27.7071C17.5196 27.8946 17.2652 28 17 28H13C12.7348 28 12.4804 27.8946 12.2929 27.7071C12.1054 27.5196 12 27.2652 12 27V24ZM22 21C22 20.7348 22.1054 20.4804 22.2929 20.2929C22.4804 20.1054 22.7348 20 23 20H27C27.2652 20 27.5196 20.1054 27.7071 20.2929C27.8946 20.4804 28 20.7348 28 21V27C28 27.2652 27.8946 27.5196 27.7071 27.7071C27.5196 27.8946 27.2652 28 27 28H23C22.7348 28 22.4804 27.8946 22.2929 27.7071C22.1054 27.5196 22 27.2652 22 27V21Z'
        stroke={color}
        strokeWidth='2'
      />
    </svg>
  );
}

export default WorkSpaceIcon;
